module.exports = __webpack_public_path__ + "img/timeline_12-e3f564.png";